<template>
  <v-menu bottom offset-y>
    <template #activator="{ on, attrs }">
      <v-btn icon :color="activatorColor" v-bind="attrs" v-on="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list :dense="dense">
      <template v-for="(item, index) in visibleItems">
        <!-- Il tooltip avvolge un <div> e non la voce stessa: Vuetify non propaga gli eventi di
             hover a una v-list-item disabilitata, ed e' proprio sulla voce disabilitata che la
             motivazione serve. -->
        <v-tooltip v-if="tooltipOf(item)" :key="index" left>
          <template #activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-list-item
                :disabled="isDisabled(item)"
                @click="handleClick(item)"
              >
                <v-list-item-icon>
                  <v-icon :color="isDisabled(item) ? 'grey' : item.color">
                    {{ item.icon }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ $t(item.label) }}
                </v-list-item-title>
              </v-list-item>
            </div>
          </template>
          <span>{{ $t(tooltipOf(item)) }}</span>
        </v-tooltip>
        <v-list-item
          v-else
          :key="index"
          :disabled="isDisabled(item)"
          @click="handleClick(item)"
        >
          <v-list-item-icon>
            <v-icon :color="isDisabled(item) ? 'grey' : item.color">
              {{ item.icon }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            {{ $t(item.label) }}
          </v-list-item-title>
        </v-list-item>
        <v-divider v-if="item.divider" :key="`divider-${index}`" />
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "ActionMenu",
  props: {
    items: {
      type: Array,
      required: true,
      validator: (items) => {
        return items.every((item) => item.icon && item.label && item.callback);
      },
    },
    context: {
      type: Object,
      default: null,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    activatorColor: {
      type: String,
      default: "techBlueDark",
    },
  },
  computed: {
    visibleItems() {
      return this.items.filter((item) => {
        if (item.visible === undefined) return true;
        if (typeof item.visible === "function") {
          return item.visible(this.context);
        }
        return item.visible;
      });
    },
  },
  methods: {
    /** Chiave i18n da mostrare a tooltip, se la voce ne dichiara una. */
    tooltipOf(item) {
      if (typeof item.tooltip === "function") return item.tooltip(this.context);
      return item.tooltip;
    },
    isDisabled(item) {
      if (item.disabled === undefined) return false;
      if (typeof item.disabled === "function") {
        return item.disabled(this.context);
      }
      return item.disabled;
    },
    handleClick(item) {
      if (!this.isDisabled(item)) {
        item.callback(this.context);
      }
    },
  },
};
</script>
